import { createSlice } from '@reduxjs/toolkit';
import type { RootState } from './store';

export type folderStateType = {
  folderId: string;
  folderName?: string;
  isFromRecipesPage?: boolean;
  isFromTrash?: boolean;
};

const initialState: folderStateType = {
  folderId: '',
  folderName: '',
  isFromRecipesPage: false,
  isFromTrash: false
};

export const folderStateSlice = createSlice({
  name: 'folderStateSlice',
  initialState,
  reducers: {
    setFolderDetails: (state, action) => {
      state.folderId = action.payload.folderId;
      state.folderName = action.payload.folderName;
      state.isFromRecipesPage = action.payload.isFromRecipesPage || false;
      state.isFromTrash = action.payload.isFromTrash || false;
    },
    resetFolderDetails: state => {
      state.folderId = '';
      state.folderName = '';
      state.isFromRecipesPage = false;
      state.isFromTrash = false;
    }
  }
});

export const { setFolderDetails, resetFolderDetails } =
  folderStateSlice.actions;

export const getFolderDetails = (state: RootState) => state.folderStateSlice;
